export default __webpack_public_path__ + "static/media/computer.30f1af18.png";